import { render } from "./OpportunityFilters.vue?vue&type=template&id=127c8d94"
import script from "./OpportunityFilters.vue?vue&type=script&lang=js"
export * from "./OpportunityFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__